module.exports = __webpack_public_path__ + "theme/assets/img/e2f1c656b5abf0b6cb8a78e897d8b048.svg";